import { gql } from "@apollo/client"
import { CreateDocumentInput, CreateDocumentPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { SetRequired } from "type-fest"

export const GENERAL_STAFF_CREATE_DOCUMENT = gql`
  mutation GeneralStaffCreateDocument(
    $entityId: ID!
    $signedDocumentId: String!
    $title: String!
    $description: String
    $date: ISO8601Date
    $tags: [String!]
  ) {
    createDocument(
      input: {
        entityId: $entityId
        signedDocumentId: $signedDocumentId
        title: $title
        description: $description
        date: $date
        tags: $tags
      }
    ) {
      errors
    }
  }
`

type MutationOption = SetRequired<
  InjectedOptions<CreateDocumentPayload, CreateDocumentInput>,
  "refetchQueries"
>

const useCreateDocument = (options: MutationOption) =>
  useMutation<CreateDocumentPayload, CreateDocumentInput>(GENERAL_STAFF_CREATE_DOCUMENT, {
    ...options,
    handlePayloadErrors: true,
  })

export default useCreateDocument
